import { inject, Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { StoreService } from "../services/store.service";

@Injectable({
  providedIn: 'root'
})
class AuthGuardService {
  private readonly fallbackRoute = '/dashboard';

  constructor(
    private router: Router,
    private storeService: StoreService,
    private snackBar: MatSnackBar
  ) { }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const hasValidSession = await this.storeService.ensureValidSession();

    if (hasValidSession && this.storeService.user) {
      const userRole = this.storeService.user!.role;
      if (next.data["roles"] && next.data["roles"].indexOf(userRole) === -1) {
        this.snackBar.open('You do not have access to that page', '', {
          duration: 4000,
          panelClass: 'snackbar-error'
        });
        await this.router.navigate([this.fallbackRoute]);
        return false;
      }
      return true;

    }
    await this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
    return false;
  }
}

export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> => {
  return inject(AuthGuardService).canActivate(next, state);
}
